<template>
  <div class="info-section">
    <section-heading v-if="content.heading" :text="content.heading" />
    <p
      v-if="content.intro"
      class="text" v-html="content.intro"></p>
    <div class="items">
      <info-block
        v-in-viewport='{ top: 200 }'
        class="info-item"
        v-for="(item, key) in content.items"
        :content="item"
        :key="key">
      </info-block>
    </div>
  </div>
</template>
<script>

import inViewport from 'vue-in-viewport-directive'
import InfoBlock from '../components/InfoBlock'
import SectionHeading from '../components/SectionHeading'
import { trackSection } from '../utils/track.js'

export default {
  directives: {
    inViewport
  },
  components: {
    InfoBlock,
    SectionHeading
  },
  data () {
    return {
      tracked: false
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.checkTracker()
    })
  },
  methods: {
    getItem (url) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/${url}`)
    },
    checkTracker () {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true
          trackSection(this.tracking.trackingId)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .info-section {
    position: relative;
    max-width: 600px;
    margin: 50px auto auto;
    padding: 50px 30px;
    color: $nos-op3-white;
    z-index: 10;
  }

  .text {
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 28px;
  }

  .info-item{
    margin-bottom: 70px;
  }

</style>



// WEBPACK FOOTER //
// src/sections/InfoSection.vue